import { render } from "./EditableItemDate.vue?vue&type=template&id=452ed5b8&scoped=true&ts=true"
import script from "./EditableItemDate.vue?vue&type=script&lang=ts"
export * from "./EditableItemDate.vue?vue&type=script&lang=ts"

import "./EditableItemDate.vue?vue&type=style&index=0&id=452ed5b8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452ed5b8"]])

export default __exports__